import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { HomeScreen } from './components/screens/HomeScreen';
import { FoldersScreen } from './components/screens/FoldersScreen';
import { AddFolderScreen } from './components/screens/AddFolderScreen';
import { FolderDetailScreen } from './components/screens/FolderDetailScreen';
import { AddStopScreen } from './components/screens/AddStopScreen';
import { StopScreen } from './components/screens/StopScreen';
import { NearStopsScreen } from './components/screens/NearStopsScreen';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/folders" element={<FoldersScreen />} />
        <Route path="/add-folder" element={<AddFolderScreen />} />
        <Route path="/folder/:folderId" element={<FolderDetailScreen />} />
        <Route path="/folder/:folderId/add-stop" element={<AddStopScreen />} />
        <Route path="/stop/:stopId" element={<StopScreen />} />
        <Route path="/near-stops" element={<NearStopsScreen />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
